import { useCallback, useMemo, useState } from 'react';
import { acLedMappingSearchResultImportMapper, getDefaultDaysOptions } from './helpers';
import { useAcLedMappingSearchGet } from 'actions/ac-led-mapping';
import { v4 as uuidv4 } from 'uuid';
import { getFormattedDate } from 'utils';
import { useEffect } from 'react';

const useLogic = () => {
  const dateOptions = useMemo(() => getDefaultDaysOptions?.(3), []);
  const [selectedDate, setSelectedDate] = useState(dateOptions?.[0]?.id);
  const [customDate, setCustomDate] = useState(null);
  const [filters, setFilters] = useState({});
  const {
    get: getTeachers,
    data: searchResult,
    isProcessing: isSearchProcessing,
  } = useAcLedMappingSearchGet();

  const { timeWindows } = acLedMappingSearchResultImportMapper(searchResult ?? {});

  const handleSelectDate = useCallback(dateId => {
    setCustomDate(null);
    setSelectedDate(dateId);
  }, []);

  const handleSelectCustomDate = useCallback(date => {
    setSelectedDate(null);
    const _date = {
      id: uuidv4(),
      date: getFormattedDate(date),
      value: date,
    };
    setCustomDate(_date);
  }, []);

  const handleSearchTeachers = () => {
    const query = {
      date: customDate?.date || dateOptions?.find(({ id }) => id === selectedDate)?.date,
      ...filters,
    };
    getTeachers('', query);
  };

  const handleFilterChange = ({ key, value }) => {
    setFilters(prevFilters => ({ ...prevFilters, [key]: value }));
  };

  const isTimeSlotAvailable = Object.keys(timeWindows ?? {})?.length > 0;

  const activeDate = customDate
    ? customDate?.date
    : dateOptions?.find(({ id }) => id === selectedDate)?.date;

  useEffect(() => {
    Object?.keys(filters)?.length && handleSearchTeachers();
  }, [selectedDate, customDate]);

  return {
    handleSelectDate,
    selectedDate,
    handleSelectCustomDate,
    customDate,
    handleSearchTeachers,
    filters,
    handleFilterChange,
    dateOptions,
    isSearchProcessing,
    timeWindows,
    isTimeSlotAvailable,
    activeDate,
  };
};

export default useLogic;
